import { hotlineText } from '@/feature/hotline/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineText;
/**
 * 匿名コンサルホットライン キャンセル schema
 */
export const hotlineCancelFormSchema = z.object({
    /**
     * キャンセル理由
     */
    cancelReason: z
        .string({
        required_error: messages.required(label.cancelReason()),
    })
        .min(1, messages.required(label.cancelReason()))
        .max(10000, messages.maxLength(10000, label.cancelReason())),
});
